import ResourceService from 'src/modules/resource/resourceService';
import Errors from 'src/modules/shared/error/errors';

const prefix = 'RESOURCE_LOCK';

const resourceLockActions = {
  ACQUIRE_STARTED: `${prefix}_ACQUIRE_STARTED`,
  ACQUIRE_SUCCESS: `${prefix}_ACQUIRE_SUCCESS`,
  ACQUIRE_HELD_BY_OTHER: `${prefix}_ACQUIRE_HELD_BY_OTHER`,
  ACQUIRE_ERROR: `${prefix}_ACQUIRE_ERROR`,
  RELEASE_SUCCESS: `${prefix}_RELEASE_SUCCESS`,
  RESETED: `${prefix}_RESETED`,

  doReset: () => (dispatch) => {
    dispatch({ type: resourceLockActions.RESETED });
  },

  doAcquire:
    (id: string, force: boolean = false) =>
    async (dispatch) => {
      if (!id) return;
      try {
        dispatch({
          type: resourceLockActions.ACQUIRE_STARTED,
          payload: { force },
        });
        const response = await ResourceService.acquireLock(
          id,
          force,
        );
        if (response && response.owned === false) {
          dispatch({
            type: resourceLockActions.ACQUIRE_HELD_BY_OTHER,
            payload: response,
          });
        } else {
          dispatch({
            type: resourceLockActions.ACQUIRE_SUCCESS,
            payload: response,
          });
        }
      } catch (error) {
        Errors.handle(error);
        dispatch({
          type: resourceLockActions.ACQUIRE_ERROR,
          payload: {
            error: (error as Error)?.message ?? null,
          },
        });
      }
    },

  doRelease: (id: string) => async (dispatch) => {
    if (!id) return;
    try {
      await ResourceService.releaseLock(id);
    } catch (error) {
      // release is best-effort; backend lock will expire anyway
      console.warn('Lock release failed:', error);
    } finally {
      dispatch({ type: resourceLockActions.RELEASE_SUCCESS });
    }
  },
};

export default resourceLockActions;
